import React from 'react'
import { Box, Typography, Fab, Stack } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import SetMultiSelect from './setList'
import { useDispatch } from 'react-redux'
import { styled } from '@mui/material/styles'
import { addedNewOptionSetAction } from '../../../store/pages/common/update'

const AddButton = styled(Fab)({
  marginLeft: 'auto'
})

export default function SetList () {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(addedNewOptionSetAction)
  }

  return (
    <Box width="100%">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ mb: 2 }}
      >
        <Typography variant='h6'>Set</Typography>
        <AddButton
          data-testid='button-add'
          size='small'
          color='primary'
          onClick={handleClick}
        >
          <AddIcon data-testid="AddIcon" />
        </AddButton>
      </Stack>

      <Box>
        <SetMultiSelect />
      </Box>
    </Box>
  )
}
